import React, { useState, useEffect, useRef } from "react";
import "./TotalEngagement.scss";
import ChartName from "../../../../../Dashboard/Charts/ChartName";
import html2canvas from "html2canvas";
import { downloadCanvasWithTitle, downloadCSVData } from "../../../../../Dashboard/Charts/utils";
import NoData from "../NoData/NoData";
import Loading from "../Loading/Loading";
import DeleteWidget from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as MoreOptions } from "../../../../../../../assets/svg/menu.svg";
import { ReactComponent as CloneIcon } from "../../../../../../../assets/svg/clone-icon.svg";
import ChartOptionsSidebar from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import InstagramPageSelector from "../InstagramPageSelector";
import { ReactComponent as ArrowIcon } from "../../../../../../../assets/svg/chevron.svg";
import { ChartFilterIcon } from "../../../../../Dashboard/Charts/ChartFilterOptions";
import { kFormatter } from "../../../../../Dashboard/Charts/utils";
import UpIcon from "../../../../../../../assets/svg/percentage_arrow.svg";
import DownIcon from "../../../../../../../assets/svg/arrow-down.svg";
import moment from "moment-timezone";
import { ReactComponent as Settings } from "../../../../../../../assets/svg/settings.svg";
import { ReactComponent as MiniMize } from "../../../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import DownloadChart from "../../../../../Dashboard/Charts/DownloadChart";
function TotalEngagement(props) {
    const [isNoData, setIsNoData] = useState(false);
    // console.log("inc deccc", props?.instagramPageList?.length, props.isIGPage, isNoData);
    const chart = useRef(null);

    const chartLoading = props.chartDataLoading;
    const chartData = props?.data;

    useEffect(() => {
        setIsNoData(props.pageStatus || props?.data?.nodata);
    }, [props.data, props.pageStatus]);

    const renderDownloadButton = (nodata) => {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: downLoadCSV },
                    { name: "PNG", downloadFn: downLoadPNG, showLoader: true },
                ]}
            />
        );
    };

    const downLoadCSV = () => {
        let chartName = "Total Engagement";
        let postCount = chartData?.eng1;

        let preCount = chartData?.eng2;

        let downLoadingData = [];
        let durationGap = chartData?.durationGap + 1;

        downLoadingData.push(["Duration", "Current", "Average", "Previous", "Percentage change"]);
        let percentage = chartData?.percentage_change;
        if (preCount) downLoadingData.push([durationGap + " days", postCount, chartData?.avg_eng, preCount, percentage + "%"]);
        else downLoadingData.push([durationGap + " days", postCount, chartData?.avg_eng, "NA", "NA"]);

        downloadCSVData(downLoadingData, props.widget?.name || chartName);
    };

    const downLoadPNG = (cb) => {
        if (chart?.current)
            return html2canvas(chart.current, { backgroundColor: "#fff", allowTaint: true, useCORS: true, scrollX: 0, scrollY: -window.scrollY }).then(
                (canvas) => {
                    cb && cb();
                    downloadCanvasWithTitle(canvas, props.widget?.name || "Total Engagement");
                },
            );
    };

    const customChangeShowMoreOptions = (e) => {
        let parent = props.containerRef.current.getBoundingClientRect();
        if (e && !props.showMoreOptions) {
            props.changeShowMoreOptions(true);
            props.changeShowMoreOptionsLoc({ x: e.clientX - parent.left - 160, y: e.clientY - parent.top });
        } else {
            props.changeShowMoreOptions(false);
            props.changeShowMoreOptionsLoc(null);
        }
    };
    const increment = () => {
        const selectedPage = props.selectedInstagramPage;
        const pageList = props.instagramPageList;
        const pageIndex = pageList.findIndex((ele) => ele.page_id === selectedPage.value);
        if (pageIndex < pageList.length - 1) {
            let item = pageList[pageIndex + 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        } else {
            let item = pageList[0];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        }
    };
    const decrement = () => {
        const selectedPage = props.selectedInstagramPage;
        const pageList = props.instagramPageList;
        const pageIndex = pageList.findIndex((ele) => ele.page_id === selectedPage.value);
        if (pageIndex === 0) {
            let item = pageList[pageList.length - 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        } else {
            let item = pageList[pageIndex - 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        }
    };

    const elements = (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName
                    IsInstagram
                    name={props.widget?.name || "Total Engagement"}
                    isIGPage={props.isIGPage}
                    info="Total engagement percentage change based on duration selection. 2 years previous duration data will be available for this chart from the day you authenticate your Business page."
                />

                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {/* {!props.isIGPage &&
                        !props.isPublic &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <ChartFilterIcon
                                chartFilterApplied={props.chartFilterApplied}
                                changeShowChartFilterOptions={props.changeChartFilter}
                                widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                                name={props.widget.name}
                            />
                        )} */}
                    {!props.isPublic && !props.isResearchDashboard && !isNoData && renderDownloadButton(isNoData)}
                    {
                        <>
                            {props.isIGPage || (props.isPublic && isNoData) ? null : (
                                <Popup
                                    className="skiptranslate"
                                    trigger={
                                        props.expand ? (
                                            <MiniMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        ) : (
                                            <MaxiMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        )
                                    }
                                    inverted
                                    content={props.expand ? "Minimize Widget" : "Maximize Widget"}
                                    size="mini"
                                    position="bottom center"
                                    style={{ zIndex: "99999" }}
                                />
                            )}
                        </>
                    }
                    {!props.isIGPage && (
                        <>
                            {props.isPublic && isNoData ? null : (
                                <MoreOptions
                                    className={isNoData && props.isIGPage ? "pointer-disabled" : "more-options"}
                                    onClick={props.isIGPage ? (e) => customChangeShowMoreOptions(e) : (e) => props.changeShowMoreOptions(e)}
                                />
                            )}
                        </>
                    )}
                </div>
                {/* {props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={props.showMoreOptionsLoc}
                        changeShowMoreOptions={props.isIGPage ? (e) => customChangeShowMoreOptions(e) : (e) => props.changeShowMoreOptions(e)}>
                        {!props.isIGPage &&
                            !props.isPublic &&
                            !props.isStandardDashboard &&
                            !props.isResearchDashboard &&
                            props.dashboardPageType !== "temporaryInsights" &&
                            props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                    <DeleteWidget onClick={props.deleteWidget} />
                                </>
                            )}
                    </ChartOptionsSidebar>
                )} */}
            </div>

            <div className="dashboard-chart dashboard-chart-slider skiptranslate">
                {!props.isIGPage && (
                    <div
                        data-html2canvas-ignore="true"
                        className={`chart-slider chart-slider-left ${props.instagramPageList.length === 1 ? "disabled" : ""}`}
                        onClick={() => decrement()}>
                        <ArrowIcon />
                    </div>
                )}
                <div className="chart-area" ref={chart}>
                    {!props.isIGPage && (
                        <InstagramPageSelector
                            selectedPage={props.selectedInstagramPage}
                            setSelectedPage={props.setSelectedInstagramPage}
                            pageList={props.instagramPageList}
                            widgetContainerRef={props.widgetContainerRef}
                        />
                    )}
                    {chartLoading && <Loading />}
                    {isNoData && !chartLoading && (
                        <div className={`${props.isIGPage ? "no__data-page-text" : "m-top"}`}>
                            <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />
                        </div>
                    )}
                    {!isNoData && !chartLoading && (
                        <div className="chart__content">
                            <div className="current__count">{kFormatter(chartData?.eng1)}</div>
                            <div className="zzz">
                                {chartData?.avg_eng && <div className="chart__text">Average Engagement : {chartData?.avg_eng}</div>}
                                {chartData?.percentage_change ? (
                                    chartData?.percentage_change > 0 ? (
                                        <div className="chart__percentage-wrapper">
                                            <img src={UpIcon} className="up__icon" />
                                            <div className="percentage__count">{chartData?.percentage_change + "%" || 0}</div>
                                        </div>
                                    ) : (
                                        <div className="chart__percentage-wrapper">
                                            <img src={DownIcon} className="down__icon" />
                                            <div className="percentage__count-less">{chartData?.percentage_change + "%" || 0}</div>
                                        </div>
                                    )
                                ) : (
                                    <div className="chart__text">NA</div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
                {!props.isIGPage && (
                    <div
                        data-html2canvas-ignore="true"
                        className={`chart-slider chart-slider-right ${props.instagramPageList.length === 1 ? "disabled" : ""}`}
                        onClick={() => increment()}>
                        <ArrowIcon />
                    </div>
                )}
            </div>
        </>
    );
    return props.isIGPage ? <div className="dashboard-widget-container">{elements}</div> : <>{elements}</>;
}
export default TotalEngagement;
